import { type FC } from "react";

import type { MagentoStockStatus } from "@jti/magento-types";

import { type SingleFlavorSelectorItem } from "../../SingleFlavorSelector.types";
import { SingleFlavorBlock } from "../SingleFlavorBlock";

const IN_STOCK: MagentoStockStatus = "IN_STOCK";

export type FlavorListItemProps = {
  item: SingleFlavorSelectorItem;
  stockStatus: MagentoStockStatus;
  isActive: boolean;
  isProductDataLoading: boolean;
  onClick: (item: SingleFlavorSelectorItem) => void;
};

export const FlavorListItem: FC<FlavorListItemProps> = ({
  item,
  stockStatus,
  isActive,
  isProductDataLoading,
  onClick,
}) => {
  const inStock = stockStatus === IN_STOCK;
  return (
    <li>
      <SingleFlavorBlock
        onClick={() => inStock && onClick(item)}
        isActive={isActive}
        label={item.name ?? ""}
        description={item.description ?? ""}
        imageUrl={item.image.url ?? ""}
        stockStatus={stockStatus}
        isStockStatusLoading={isProductDataLoading}
        attributes={item.attributes ?? []}
      />
    </li>
  );
};
